import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

import { useRegisteredInfoProviderOptions } from '../../hooks/useRegisteredInfoProviderOptions';

// Select over the info providers the backend has parsers registered for, fetched through the
// Apollo cache. Controlled with plain strings: `value` and `onChange(value | null)`.
// react-select's menu is absolutely positioned with an auto z-index, so later siblings (other
// form controls) paint over it. Lift it explicitly.
const SELECT_STYLES = {
  menu: (base) => ({ ...base, zIndex: 9999 })
};

const RegisteredInfoProvidersSelect = ({ value, onChange, placeholder, isClearable }) => {
  const { options, loading } = useRegisteredInfoProviderOptions();

  const selectedOption = options.find((option) => option.value === value) || null;

  return (
    <Select
      className="basic-multi-select"
      classNamePrefix="select"
      isClearable={isClearable}
      isLoading={loading}
      onChange={(option) => onChange(option ? option.value : null)}
      options={options}
      placeholder={placeholder}
      styles={SELECT_STYLES}
      value={selectedOption}
    />
  );
};

RegisteredInfoProvidersSelect.propTypes = {
  isClearable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string
};

RegisteredInfoProvidersSelect.defaultProps = {
  isClearable: false,
  placeholder: 'Proveedor',
  value: ''
};

export default RegisteredInfoProvidersSelect;
